import React from 'react'
import USDefaultTemplate from 'src/components/template/us'

export default (props) => {
  return (
    <USDefaultTemplate
      location={props.location}
      // TEMPORARY NBC DISPUTE
      // video={videos.news.videoUrl}
      // annotations={videos.news.annotations}
      title="Follow the day's big stories"
      subtitle="Stream live news from any device"
      tagline="Plus, get our News add-on for even more coverage"
      networkSet="news"
    />
  )
}
